import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { FormControlName, NgModel } from '@angular/forms';

@Directive({
  selector:
    '[axis-floating-label]'
})
export class AxisFloatingLabelDirective implements OnInit {
  private el: any;
  private isFocus = false;
  constructor(
    private elementRef: ElementRef,
    private model: NgModel,
    private renderer: Renderer2,
    private formControlName: FormControlName
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    if (this.formControlName && this.formControlName.valueChanges) {
      this.formControlName.valueChanges
        .subscribe(value => {
          this.addRemoveClass();
        });
    } else if (
      this.model &&
      this.model.valueChanges &&
      this.model.hasOwnProperty('viewModel')
    ) {
      this.model.valueChanges.subscribe(value => {
        this.addRemoveClass();
      });
    }
    this.addRemoveClass();
    this.checkPlaceholder();
  }

  addRemoveClass() {
    let node = this.el;
    if (node && this.el.parentElement) {
      node = this.el.parentElement;
      if (node.classList.contains('axis-dropdown')) {
        node = node.parentElement;
      }
    }
    this.renderer.removeClass(node, 'axis-form-control-filled');
    if (this.isFocus || this.el.value === 0 || this.el.value) {
        this.renderer.addClass(node, 'axis-form-control-filled');
      }
  }

  @HostListener('input', ['$event', '$event.target.value'])
  onInputChange(event, value) {
    this.addRemoveClass();
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.isFocus = true;
    this.addRemoveClass();
    this.checkPlaceholder();
  }

  @HostListener('blur', ['$event', '$event.target.value'])
  onBlur(event, value) {
    this.isFocus = false;
    this.addRemoveClass();
    this.checkPlaceholder();
  }
  checkPlaceholder() {
    let node = this.el;
    if (node && this.el.parentElement) {
      node = this.el.parentElement;
      if (node.classList.contains('axis-dropdown')) {
        node = node.parentElement;
      }
    }
    if (this.el.getAttribute('placeholder') && this.el.getAttribute('placeholder').length > 0) {
      this.renderer.addClass(node, 'axis-form-control-filled');
    }
  }
}
